module.exports = __webpack_public_path__ + "img/mag.090c6ca1.png";